// import 'lazysizes/plugins/respimg/ls.respimg';
// import 'lazysizes/plugins/object-fit/ls.object-fit';
import lazySizes from 'lazysizes';
import objectFitImages from 'object-fit-images';
import '../styles/lazysizes.css';
import '../styles/picture.css';

if (document.querySelector('.bx-ie')) {
    Object.assign(lazySizes.cfg, {
        init: false,
    });
}

setTimeout(() => {
    objectFitImages();
}, 500);
